import httpClient from 'utils/httpClient'

export const list = async (lane: number) => {
  const { data } = await httpClient.get(
    `/api/proposals/lanes/${lane}/proposals/`
  )
  return data
}

export const partialUpdate = async (
  lane: number,
  carrier: number,
  payload: Partial<LaneProposal>
) => {
  const { data } = await httpClient.patch(
    `/api/proposals/lanes/${lane}/proposals/${carrier}/`,
    payload
  )
  return data
}
